export class MemberTran {

  flow_id: number
  user_id: number
  date: string
  amount: number
  comment: string

  constructor(data: any = {}) {
    this.flow_id = data.flow_id
    this.user_id = data.user_id
    this.date = data.date
    this.amount = data.amount
    this.comment = data.comment
  }

  get editLink(): string {
    return `/finance/users/${this.user_id}/${this.flow_id}`
  }

}



// WEBPACK FOOTER //
// ./src/app/models/user/member-tran.ts